import { Component, ContentChild, input, computed, signal, effect, WritableSignal, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_PROGRESSBARS } from "@progress/kendo-angular-progressbar";
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { IVesselMovement, IVesselStop, IVesselVisit, selectEditingVesselActivities, selectSelectedVesselActivitiesIndices, selectTransitStatuses, UpdateSelectedVesselActivitiesIndices, UpdateSelectedVesselVisit, VesselActivityPair, VesselStopTypeForStepper, VesselTransitStatus } from '@pmis3/vessel-activity-core';
import { VesselActivityHelper } from '@pmis3/vessel-activity-core';
import { VesselVisitStepperStopSummaryComponent } from './vessel-visit-stepper-stop-summary/vessel-visit-stepper-stop-summary.component';
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_POPUP } from "@progress/kendo-angular-popup";
import { VesselVisitStepperPopupComponent } from './vessel-visit-stepper-popup/vessel-visit-stepper-popup.component';
import { Store } from '@ngrx/store';
import { VesselVisitStepperHelper } from './vesselVisitStepper.helper';
import { IStepperStep } from './data/stepperStep';

@Component({
	selector: 'pmis3-vessel-visit-stepper',
	standalone: true,
	imports: [
		CommonModule,
		KENDO_PROGRESSBARS,
		KENDO_BUTTONS,
		VesselVisitStepperStopSummaryComponent,
		KENDO_INPUTS,
		KENDO_POPUP,
		VesselVisitStepperPopupComponent
	],
	templateUrl: './vessel-visit-stepper.component.html',
	styleUrl: 'vessel-visit-stepper.component.scss'
})
export class VesselVisitStepperComponent {
	vesselVisit = input.required<IVesselVisit>();
	editingVesselActivities = this.store.selectSignal(selectEditingVesselActivities);
	statuses = this.store.selectSignal(selectTransitStatuses);
	selectedIndices = this.store.selectSignal(selectSelectedVesselActivitiesIndices)

	disabled = input(false);
	readonly = input(false);

	state = computed(() => {
		const selectedIndex = this.selectedIndices()?.find(selection => selection.type === VesselStopTypeForStepper.Shift)?.index ?? null
		return {
			selectedStep: signal(selectedIndex)
		}
	})

	LPOC = computed(() => this.vesselVisit().lastPortOfCallName ?? this.vesselVisit().lastPortOfCall?.shortCode);
	NPOC = computed(() => this.vesselVisit().nextPortOfCallName ?? this.vesselVisit().nextPortOfCall?.shortCode);
	safeStepsLength = computed(() => Math.max(this.steps()?.length ?? 1));

	progressBarPosition = signal(0);
	activePopupIndex = signal<number | null>(null);

	steps = computed(() => {
		const editingVesselActivities = this.editingVesselActivities();
		const vesselActivities = editingVesselActivities && editingVesselActivities.length > 0
			? editingVesselActivities
			: (this.vesselVisit().vesselActivities ?? []);
		const addButtonVisible = !this.readonly();

		const vesselActivitiesWithProgress = VesselVisitStepperHelper.calculateProgressForActivities(vesselActivities);
		return VesselVisitStepperHelper.calculateSteps(vesselActivitiesWithProgress, this.statuses(), addButtonVisible)
	});

	constructor(private store: Store<any>) { }

	toggleAddMovementPopup(index: number) {
		const current = this.activePopupIndex();
		const newIndex = current === index ? null : index;
		this.activePopupIndex.set(newIndex);
	}

	onAddMovement(index: number) {
		this.toggleAddMovementPopup(index);
	}

	onSelectStop(index: number) {
		this.state().selectedStep.set(index);
		const vesselActivities = this.editingVesselActivities() ?? [];
		const selectedIndices = VesselActivityHelper.getIndicesForEditingOnSelectingStop(index, vesselActivities);
		this.store.dispatch(UpdateSelectedVesselActivitiesIndices({ indices: selectedIndices }));
	}

	getColorOfStop(step: IStepperStep) {
		if (step.stop) {
			return 'bg-'+VesselActivityHelper.getStatusColour(step.status)
		} else {
			return 'bg-transparent'
		}

	}
	getBorderColorOfStop(step: IStepperStep) {
		if (step.stop) {
			return 'border-'+ VesselActivityHelper.getStatusColour(step.status)+'-light'
		}
		return ''
	}
}